export function cleanHash() {
  window.history.replaceState(
    window.history.state,
    document.title,
    window.location.pathname + window.location.search
  );
}
